type EmbeddedFailureDetails = {
  category: 'auth' | 'calendar' | 'checkin' | 'video' | 'workout_data'
  message: string
  name: string
  workoutId?: number
}

declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void
    }
  }
}

const MAX_MESSAGE_LENGTH = 1000

const EXPECTED_CHECK_IN_FAILURES = [
  'already checked in',
  'already checked-in',
  'check-in limit',
  'check in limit',
  'limit reached',
  'not eligible',
  'outside the check-in window',
  'check-in window is closed',
]

export const shouldReportCheckInFailure = (message: string): boolean => {
  const normalizedMessage = message.toLowerCase()

  return !EXPECTED_CHECK_IN_FAILURES.some((expectedFailure) =>
    normalizedMessage.includes(expectedFailure),
  )
}

export const reportEmbeddedFailure = ({
  category,
  message,
  name,
  workoutId,
}: EmbeddedFailureDetails): boolean => {
  if (!window.ReactNativeWebView?.postMessage) return false

  window.ReactNativeWebView.postMessage(
    JSON.stringify({
      type: 'WEBVIEW_UX_FAILURE',
      payload: {
        category,
        message: message.slice(0, MAX_MESSAGE_LENGTH),
        name,
        url: `${window.location.origin}${window.location.pathname}`,
        workoutId,
      },
    }),
  )

  return true
}
